import { createAction } from "redux-actions";
import { moduleSlug } from "modules/ConfigManager/constants";

export const clearConfigs = createAction(`${moduleSlug}/CLEAR_CONFIGS`);

export const getConfigsEntities = createAction(`${moduleSlug}/GET_ENTITIES`);
export const getConfigsEntitiesSuccess = createAction(`${moduleSlug}/GET_ENTITIES/SUCCESS`);
export const getConfigsEntitiesError = createAction(`${moduleSlug}/GET_ENTITIES/ERROR`);

export const setWorkersDialog = createAction(`${moduleSlug}/SET_WORKERS_DIALOG`);
export const mergeWorkersDialog = createAction(`${moduleSlug}/MERGE_WORKERS_DIALOG`);
export const changeWorkers = createAction(`${moduleSlug}/CHANGE_WORKERS`);

export const enabledConfig = createAction(`${moduleSlug}/ENABLED_CONFIG`);
export const enabledConfigError = createAction(`${moduleSlug}/ENABLED_CONFIG/ERROR`);

export const setSelectedConfigs = createAction(`${moduleSlug}/SET_SELECTED_CONFIGS`);
export const setSelectedDataSelectors = createAction(`${moduleSlug}/SET_SELECTED_DATA_SELECTORS`);
export const setSelectedDataNormalizers = createAction(`${moduleSlug}/SET_SELECTED_DATA_NORMALIZERS`);
export const setSelectedBlockSelectors = createAction(`${moduleSlug}/SET_SELECTED_BLOCK_SELECTORS`);
export const setSelectedTemplates = createAction(`${moduleSlug}/SET_SELECTED_TEMPLATES`);

export const deleteConfig = createAction(`${moduleSlug}/DELETE_CONFIG`);
export const deleteConfigError = createAction(`${moduleSlug}/DELETE_CONFIG/ERROR`);

export const enabledCheckedConfig = createAction(`${moduleSlug}/ENABLED_CHECKED_CONFIGS`);
export const enabledCheckedConfigError = createAction(`${moduleSlug}/ENABLED_CHECKED_CONFIGS/ERROR`);

export const exportScheme = createAction(`${moduleSlug}/EXPORT_SCHEME`);

export const scheduleCITests = createAction(`${moduleSlug}/SCHEDULE_CI_TESTS`);

export const setPublishRequestDialog = createAction(`${moduleSlug}/SET_PUBLISH_REQUEST_DIALOG`);
export const mergePublishRequestDialog = createAction(`${moduleSlug}/MERGE_PUBLISH_REQUEST_DIALOG`);
export const publishRequest = createAction(`${moduleSlug}/PUBLISH_REQUEST`);
